var map = {
	"./chat-icon-bottom-nav-mobile-active.webp": 2703,
	"./chat-icon-bottom-nav-mobile.webp": 2704,
	"./home-icon-bottom-nav-mobile-active.webp": 2705,
	"./home-icon-bottom-nav-mobile-active_b.webp": 2706,
	"./home-icon-bottom-nav-mobile.webp": 2707,
	"./home-icon-bottom-nav-mobile_b.webp": 2708,
	"./me-icon-bottom-nav-mobile-active.webp": 2709,
	"./me-icon-bottom-nav-mobile.webp": 2710,
	"./promo-icon-bottom-nav-mobile-active.webp": 2711,
	"./promo-icon-bottom-nav-mobile.webp": 2712,
	"./sponsor-icon-bottom-nav-mobile-active.webp": 2713,
	"./sponsor-icon-bottom-nav-mobile.webp": 2714,
	"./stream-icon-bottom-nav-mobile-active.webp": 2715,
	"./stream-icon-bottom-nav-mobile.webp": 2716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2702;